module.exports = __webpack_public_path__ + "static/media/more_banner_mitrais_gptw.a3b0d535.gif";